// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"deal-alert-search_uk-open__VOnnK","grecaptcha-badge":"deal-alert-search_grecaptcha-badge__K0yGm","search":"deal-alert-search_search__HePBA","searchResults":"deal-alert-search_searchResults__6GosI","searchInput":"deal-alert-search_searchInput__JPOeD","noResults":"deal-alert-search_noResults__ZpSpR","card":"deal-alert-search_card__5Pmow"};
    if(module.hot) {
      // 1793877034175
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  